import styled from '@emotion/styled';
import { Modal } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: ${COLORS.black};
  & > span:nth-child(1) {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  & > span:nth-child(2) {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 36px;
  }
`;

export const ChildrenWrapper = styled.div`
  width: 100%;
  padding: 21px 0px 21px 0px;
  flex-grow: 0;
  background-color: white;
`;

export const StyledBasicModal = styled(Modal)`
  max-width: 766px;
`;

export const StyledModalWindow = styled(StyledBasicModal)`
  height: 235px;
  padding: 0px;
`;

export const ModalWindowDefaultImages = styled(Modal)`
  border: 0;
  border-radius: 0;
  padding: 42px 41px 40px 41px;

  & div::not(.default-images-error-content) {
    padding: 0px;
  }
  max-width: 766px !important;
  max-width: 766px !important;
`;

export const StyledModalWrapper = styled.div`
  height: 100vh;
  width: 100%;

  position: fixed;
  top: 0;
  left: 0;

  z-index: 200;

  background-color: rgba(0, 0, 0, 0.6);

  overflow-y: auto;
`;

export const StyledModal = styled.div<{ width?: string; paddingBottom?: string; paddingTop?: string }>`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ width }) => (width ? `${width}` : '766px')};

  padding-top: ${({ paddingTop }) => (paddingTop ? `${paddingTop}` : '42px')};
  padding-bottom: ${({ paddingBottom }) => (paddingBottom ? `${paddingBottom}` : '42px')};

  display: flex;
  align-items: center;
  flex-direction: column;

  background-color: ${COLORS.white};
`;

export const StyledModalError = styled.span<{
  color?: string;
}>`
  position: absolute !important;
  top: 84px;
  font-size: 10px;
  color: ${({ color }) => color || COLORS.cadmiumViolet};
`;

export const StyledModalHeading = styled.span<{ color?: string }>`
  width: 100%;

  background-color: ${COLORS.white};

  font-size: 24px;
  font-weight: bold;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: 23px;

  color: ${({ color }) => color || `${COLORS.black}`};
`;

export const StyledModalText = styled.p`
  margin: 0;
  text-align: center;
  line-height: 1.63;
  font-weight: normal;

  & > span {
    font-size: 24px;
    vertical-align: bottom;
  }
`;

export const StyledModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: normal;
  margin-top: 10px;
`;

export const StyledResetModalWindow = styled(Modal)`
  width: 766px;
  max-width: 766px;
  height: 235px;
  position: absolute !important;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  border: 0;
  border-radius: 0;
  padding: 0;
  padding-top: 18px;
  padding-bottom: 17px;
  margin: 0 !important;
  font-weight: normal;
  button:first-of-type {
    position: absolute !important;
    top: 7px;
    right: 7px;
    margin: 0;
    padding: 0;
  }
`;

export const StyledDeleteModalWindow = styled(StyledResetModalWindow)`
  min-width: 510px;
  max-width: fit-content;
  height: 261px;
  padding: 0;
  & > div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 43px 111px 48px 110px;
  }
  color: ${COLORS.black};
`;
